import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { PageLayoutService } from "@shared/components/page-layout/page-layout.service";
import type { ParentDrawerRequest } from "@shared/components/page-layout/page-layout.types";

@Component(
    {
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ''
}
)
export class LayoutDrawerComponent {
    protected layout = inject(PageLayoutService);

    @Input() public drawer: ParentDrawerRequest;
    public title?: string | null;
}